import React, { Component } from 'react';
import Chip from '@material-ui/core/Chip';
import Typehead from './../../../commons/Typehead.js';
import InwardingApiHandler from './../InwardingApiHandler.js';
import Collapse from '@material-ui/core/Collapse';
import completed from './../../../assets/img/completed.png';
import not_completed from './../../../assets/img/not_completed.png';
import Loader from './../../../commons/Loader.js';
import ErrorBox from './../../../commons/ErrorBox';
import InputFloating from './../../../commons/InputFloating.js';

const numfor = new Intl.NumberFormat('en-IN', {
	style: 'currency',
	currency: 'INR',
	minimumFractionDigits: 0
});

const datefor = new Intl.DateTimeFormat('en-GB', {
	year: 'numeric',
	month: 'short',
	day: '2-digit'
});


export default class Inwarding extends Component {
	constructor(props) {
		super(props);
		this.state = {
			vendors: [],
			open: false,
			selectedVendor: null,
			selectedNumber: '',
			searchedInvoices: null,
			showLoader: false,
			error: null
		}
	}

	getAllTheVendors = () => {
		InwardingApiHandler.getAllVendors()
			.then((resp) => {
				this.setState({ vendors: resp.vendors });
			}).catch((error) => {

			}).finally(() => {

			})
	}

	searchInvoices = () => {
		this.setState({ showLoader: true });
		let id = this.state.selectedVendor.boltVendorId;
		//number here is the invoice number
		let number = this.state.selectedNumber;
		InwardingApiHandler.getInvoiceBySearch(id, number)
			.then((resp) => {
				this.setState({ searchedInvoices: resp, open: false });
			}).catch((error) => {
				this.setState({ error: error.error.error });
			}).finally(() => {
				this.setState({ showLoader: false });
			})
	}

	closeError = () => {
		this.setState({ error: null });
	}

	openSearchForm = () => {
		const { open } = this.state;
		this.setState({ open: !open });
	}

	componentWillMount() {
		this.getAllTheVendors();
	}

	deleteSearchData = () => {
		this.setState({ searchedInvoices: null, selectedNumber: '', selectedVendor: null });
	}

	createNewInvoice = () => {
		window.location.assign('/Inwarding/Invoice')
	}

	onSelection = (itm) => {
		this.setState({ selectedVendor: itm });
	}

	invoiceNumberAdded = (e) => {
		this.setState({ selectedNumber: e.target.value });
	}

	invoiceSelected = (invoice) => {
		this.props.history.push({
			pathname: '/Inwarding/AddPallet/' + invoice.vendorInvoiceId
		});
	}

	getInvoicesToShow = () => {
		return this.state.searchedInvoices.map((i, index) => {
			return (<div className="v-invoice-wrapper" key={index} onClick={() => { this.invoiceSelected(i) }}>
				<div style={{ padding: '12px' }}>
					<div className="row op-nt-imp">
						<div className="col-xs-7">
							{i.vendor.orgId}
						</div>
						<div className="col-xs-5 text-right">
							Invoice date
						</div>
					</div>
					<div className="row v-imp-txt" style={{ marginTop: '4px' }}>
						<div className="col-xs-8">
							{i.vendor.boltVendorDisplayName}
						</div>
						<div className="col-xs-4 text-right unbreak">
							{datefor.format(i.invoiceDate)}
						</div>
					</div>
					<div className="v-inv-n">
						Invoice # {i.vendorInvoiceNumber}
					</div>
					<div className="v-imp-txt">
						Jumbotail Wholesale
					</div>
					<div className="v-imp-txt" style={{ marginTop: '8px' }}>
						{numfor.format(i.invoiceAmount)}
					</div>
					<div className="c-b-u text-right">
						Created by {i.userId}
					</div>
				</div>
				<div className="v-inv-sts" style={(i.vendorInvoiceStatus === 'INWARDING_COMPLETE' ? { color: '#55a256' } : { color: '#ee8f29' })}>
					{i.vendorInvoiceStatus}<img src={(i.vendorInvoiceStatus === 'INWARDING_COMPLETE' ? completed : not_completed)} style={{ height: '20px', marginLeft: '5px' }} alt="status" />
				</div>
			</div>);
		})
	}

	render() {
		const { open, selectedVendor, selectedNumber, searchedInvoices, vendors } = this.state;
		return (
			<div>
				<div className="search-box-outer">
					<div className="box-heading">View Inwarding Documents list</div>
					<div className="top-ten">
						<button className={"btn " + (open ? 'search-btn-blue' : 'search-btn-primary')} onClick={this.openSearchForm}>Search By {open ? <i className="fas fa-chevron-up" style={{ marginLeft: '5px' }}></i> : <i className="fas fa-chevron-down" style={{ marginLeft: '5px' }}></i>}</button>
					</div>
					<Collapse in={open}>
						<div className="top-ten">
							<div className="row">
								<div className="col-md-4 top-ten">
									<div>
										<Typehead type={'text'} className={'in-mob-box'} placeholder={'Vendor Name'} options={vendors} onSelection={this.onSelection} value={'boltVendorDisplayName'} required={true} selected={selectedVendor} />
									</div>
								</div>
								<div className="col-md-4 top-ten">
									<div>
										<InputFloating type="text" label="Invoice No." value={selectedNumber} onChange={this.invoiceNumberAdded} />
									</div>
									<div className="requiredText">
										*Required
									</div>
								</div>
								<div className="col-md-1 top-ten text-right">
									<button className={"btn " + (selectedVendor && selectedNumber ? 'btn-jt-blue-small' : 'btn-jt-dis-small')} disabled={(selectedVendor && selectedNumber ? false : true)} onClick={this.searchInvoices}>Search</button>
								</div>
							</div>
						</div>
					</Collapse>
				</div>
				{(searchedInvoices) ?
					<div style={{ padding: '10px' }}>
						<div>
							<Chip label={selectedVendor.boltVendorDisplayName + ', Invoice No.' + selectedNumber} onDelete={this.deleteSearchData} color="primary" variant="outlined" classes={{ root: 'chipRootWhite', colorPrimary: 'chipColorBlue', deleteIcon: 'chipColorBlue', label: 'brokenText' }} />
						</div>
						<div className="top-ten" style={{ color: '#808080', fontSize: '12px', lineHeight: '15px', letterSpacing: '0.0px' }}>
							{searchedInvoices.length} Result
						</div>
						<div className="top-ten">
							{this.getInvoicesToShow()}
						</div>
					</div> : null
				}
				{(this.state.showLoader) ?
					<Loader /> : null
				}
				{(this.state.error) ?
					<ErrorBox errorText={this.state.error} closeError={this.closeError} /> : null
				}
				<button className="fabIcon" onClick={this.createNewInvoice}>+</button>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/screens/Inwarding/Components/Inwarding.js